import { Form } from "formik";
import styled from "styled-components";

export const Container = styled.div`
  padding: 20px 0;

  h3 {
    padding: 0;
    width: 100%;
    font-family: var(--font-display);
    font-style: normal;
    font-weight: normal;
    font-size: 1.5rem;
    line-height: 1.75rem;
    letter-spacing: 0.5px;
    color: var(--color-purple);
    margin-bottom: 0;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(195, 195, 195, 0.5);
    margin-bottom: 27px;

    button {
      padding: 0;
      height: auto !important;
      background: none;
      border: none;
    }
  }

  .separator {
    margin-top: 20px;
  }

  .address-items h3 {
    margin-bottom: 20px;
  }

  .order-item {
    display: flex;
    flex-direction: column;
    align-items: start;
    p {
      font-size: 1.12rem;
      margin: 0;
    }
    span {
      font-size: 1rem;
      word-break: break-word;
    }
  }

  .danger {
    background: red;
    border-color: red;

    &:hover {
      color: white;
    }
  }

  .accordion-items {
    margin-top: 10px;
    row-gap: 20px;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(3, 250px);

    &.patients {
      margin-bottom: 20px;
    }
  }
`;

export const ButtonsHolder = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 30px;
  width: 100%;
  max-width: 500px;
  margin: 40px auto 0;
  justify-content: center;
`;

export const ModalPersonErrorStyle = styled.div`
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  height: 100%;

  h1 {
    margin-top: 30px;
    font-size: 1.8rem;
    line-height: 1.5rem;
    color: var(--color-purple);
    text-align: center;
    font-weight: bold;
  }

  h2 {
    font-size: 1.1rem;
    line-height: 1rem;
    color: var(--color-purple);
    margin-top: 2rem;
    font-weight: bold;
  }

  p {
    margin: 0;
  }

  .patient-error {
    padding: 0 10px;
  }

  .patient-duplicated {
    margin-top: 60px;
    h2 {
      margin: 0;
    }
  }

  .patient-duplicated.selected {
    border: 2px solid gray;
  }

  .duplicated-items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .duplicated-item {
    padding: 20px 10px;
    border: 1px solid #e9e9e9;
    border-radius: 20px;
    cursor: pointer;
    flex: 1;
    position: relative;

    &.selected {
      background: #e1dcdc1a;

      &::after {
        content: "✔";
        width: 20px;
        height: 20px;
        border: 1px solid gray;
        background: #e1dcdc1a;
        border-radius: 3px;
        position: absolute;
        text-align: center;
        top: 50%;
        right: 20px;
        color: black;
        transform: translateY(-50%);
      }
    }
  }

  .duplicated-item:hover {
    background: #e1dcdc1a;
  }

  .buttons-holder {
    padding: 20px 0;
    margin-top: auto;
    display: flex;
    gap: 20px;
    justify-content: center;
  }
`;

export const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  .page-heading {
    padding: 20px 0;
    box-shadow: unset;
    width: 100%;
  }

  .wrapper-header-content {
    width: 100%;
  }
`;

export const AccordionForm = styled(Form)`
  .buttons-holder {
    margin-left: auto;
    width: 100%;
    display: flex;
    gap: 5px;
    justify-content: flex-end;

    button {
      margin-top: 10px;
      display: flex;
      gap: 5px;
      padding: 5px 10px;
    }
  }
`;
